import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../../services/api";
import Constants from "../../../services/constants";
import { hideSkelton, showSkelton} from "../loaderSlice";

const initialState = {
  data: [],
};

export const getEventsAction = createAsyncThunk(
  "events/get",
  async ({ projectId }, { dispatch }) => {
    try {
      dispatch(showSkelton());
      const res = await api("get", Constants.END_POINT.events + "project/" + projectId, {});
      if (res?.success && res?.data) {
        dispatch(setEventsData(res?.data));
      } else {
        // dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
    //   dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
      dispatch(hideSkelton());
    }
  }
);


const eventsSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    setEventsData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setEventsData } = eventsSlice.actions;

export default eventsSlice.reducer;
